<template>
  <div>
    <TopNavigation :TopAct="'2'"/>
    <div v-if="$store.state.webNavigator=='pc'">
      <div class="aboutProducts">
        <div class="aboutProducts-banner5 positionRE">
          <p class="font36px aP-banner-tlt">健康瘦身 发现更好的自己</p>
          <p class="aP-banner-p lineHeight17">
            脂玫乐，专业健康瘦身品牌，主张辨证施法的健康瘦身理念，<br>
            组建名医研发团、技术顾问团和体脂督导团三大核心团队，<br>
            创新提供 <b>“体质管理+营养管理+作息管理”</b> 三位一体的个性化健康瘦身方案和全程跟踪指导服务。<br>
            创始以来，脂玫乐以“高效、健康、稳定”赢得了广大减肥客户的信赖与赞誉，树立了良好的市场口碑，<br>
            于2018年先后获评为“中国3.15诚信品牌”“湖南省创新创优·质量品牌双承诺单位”等荣誉,<br>
            是中国广受客户喜爱和拥有强势竞争力的健康瘦身品牌之一。
          </p>
        </div>
        <div class="aboutProducts-banner1 positionRE">
          <div class="aP-banner1-text">
            <p class="font36px aP-banner-tlt">湖南省中医药研究院 联合研制</p>
            <p class="aP-banner-p">
              建立700㎡湖南省中医药研究院战略合作研发实验室，特聘湖南省中医药研究院制剂室主任彭艳梅等权威专家为技术顾问， <br>
              在脂玫乐瘦身产品研发、技术公关、成果转化、工艺设备等方面给予指导与引领，助力脂玫乐产品研制的标准化、规范化。
            </p>
            <p class="aP-banner-p aP-banner-p1">
              <span
                class="aP-banner-name">彭艳梅</span><span>—— 湖南省中医药研究院制剂室主任、国家特殊医学用途配方食品审评专家、湖南省食品安全标准和风险评估专家委员会委员。</span>
            </p>
          </div>
          <div class="aP-banner1-nameImgBar">
            <img title="" class="aP-banner1-nameImg aP-nameImg1"
                 :src="src1" alt="">
            <img title="" class="aP-banner1-nameImg aP-nameImg3"
                 :src="src3"
                 alt="">
            <img title="" class="aP-banner1-nameImg aP-nameImg4"
                 :src="src4" alt="">
          </div>
        </div>
        <div class="aboutProducts-banner2 positionRE">
          <div class="aP-banner1-text">
            <p class="font36px aP-banner-tlt">名医研发团·健康瘦身名医配方</p>
            <p class="aP-banner-p">
              脂玫乐携手名老中医刘明汉、张良圣、谷井文以及膏方大师蒋孟良领衔的名医团队，深入研究经典古方、名方，精心改良适宜现代人体质和生<br>活环境的健康瘦身配方。
            </p>
            <p class="aP-banner-p aP-banner-p2">
              <span class="aP-banner-name">刘明汉</span><span>—国务院政府特殊津贴专家、全国卫生文明建设先进工作者、全国优秀卫生先进工作者</span>
            </p>
            <p class="aP-banner-p aP-banner-p2">
              <span class="aP-banner-name">张良圣</span><span>—全国先进工作者、全国卫生系统先进工作者、全国第五批名老中医药专家学术指导老师</span>
            </p>
            <p class="aP-banner-p aP-banner-p2">
              <span class="aP-banner-name">谷井文</span><span>—国务院政府特殊津贴专家、全国先进工作者、全国卫生系统先进工作者</span>
            </p>
            <p class="aP-banner-p aP-banner-p2">
              <span class="aP-banner-name">蒋孟良</span><span>—国家中医药管理局重点学科中药炮制学科带头人、国家中药炮制基地建设传承人、国家中医管理局中医药科技专家</span>
            </p>
          </div>
          <div class="aP-banner1-nameImgBar">
            <img title="" class="aP-banner1-nameImg aP-nameImg5"
                 :src="src5"
                 alt="">
            <img title="" class="aP-banner1-nameImg aP-nameImg6"
                 :src="src6"
                 alt="">
            <img title="" class="aP-banner1-nameImg aP-nameImg7"
                 :src="src7" alt="">
            <img title="" class="aP-banner1-nameImg aP-nameImg8"
                 :src="src8"
                 alt="">
          </div>
        </div>
        <div class="aboutProducts-banner3 positionRE">
          <div class="aP-banner1-text">
            <p class="font36px aP-banner-tlt" style="color: #ffffff">国家药典标准精选 道地药材</p>
            <p class="aP-banner-p" style="color: #ffffff">
              遵循道地药材的选材原则，从采购、验收等源头环节严控把关，所有原材均从全国正规药材厂选购，并由专业执业药师二次管控验收，以高达 <br> 5%的拒收率，确保药材质量符合甚至高于国家药典、省炮制规范标准。
            </p>
          </div>
          <div class="aP-banner3-bg"></div>
        </div>
        <div class="aboutProducts-banner4 positionRE">
          <div class="aP-banner1-text">
            <p class="font36px aP-banner-tlt" style="color: #282828">产品版图</p>
            <p class="aP-banner-p" style="color: #282828">
              <span style="font-weight: bold">品类：</span><span>中医药食同源食品、保健品、OTC &nbsp;&nbsp;&nbsp;&nbsp;</span><span
              style="font-weight: bold">剂型：</span><span>膏滋、固体饮料、液态饮品、片剂</span>
            </p>
          </div>
          <div class="aP-banner4-bg">

          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="phone-aboutProducts">
        <div class="banner5-Box">
          <div class="banner-tlt">
            健康瘦身 发现更好的自己
          </div>
          <div class="banner5-text1 banner-textP">
            脂玫乐，专业健康瘦身品牌，<br>
            主张辨证施法的健康瘦身理念，组建名医研发团、技术顾问团<br>
            和体脂督导团三大核心团队，<br>
            创新提供“体质管理+营养管理+作息管理”三位一体<br>
            的个性化健康瘦身方案和全程跟踪指导服务。<br>
            创始以来，脂玫乐以“高效、健康、稳定”<br>
            赢得了广大减肥客户的信赖与赞誉，树立了良好的市场口碑，<br>
            于2018年先后获评为“中国3.15诚信品牌”<br>
            “湖南省创新创优·质量品牌双承诺单位”等荣誉,<br>
            是中国广受客户喜爱和拥有强势竞争力的健康瘦身品牌之一。
          </div>
        </div>
        <div class="banner1-Box">
          <div class="banner-tlt">
            湖南省中医药研究院<span class="col33333"> - </span>联合研制
          </div>
          <div class="banner-textP banner1-text1">
            建立700㎡湖南省中医药研究院战略合作研发实验室，
            特聘湖南省中医药研究院制剂室主任彭艳梅等权威专家为技术顾问，在脂玫乐瘦身产品研发、技术公关、成果转化、工艺设备等方面给予指导与
            引领，助力脂玫乐产品研制的标准化、规范化。
          </div>
          <div class="banner1-imgBox"></div>
          <div class="banner-textP banner1-text2">
            <span class="col33333">彭艳梅</span>—— 湖南省中医药研究院制剂室主任、国家特殊医学用途配方食品审评专家、湖南省食品安全标准和风险评估专家委员会委员。<br>
          </div>
        </div>
        <div class="banner2-Box">
          <div class="banner-tlt">
            名医研发团<span class="col33333"> - </span>健康瘦身名医配方
          </div>
          <div class="banner-textP banner2-text1">
            脂玫乐携手名老中医刘明汉、张良圣、谷井文以及膏方大师蒋孟良领衔的名医团队，深入研究经典古方、名方，精心改良适宜现代人体质和生活环境的健康瘦身配方。
          </div>
          <div class="banner2-imgBox"></div>
          <div class="banner-textP banner2-text2">
            <span class="col33333">刘明汉</span>—— 国务院政府特殊津贴专家、全国卫生文明建设先进工作者、全国优秀卫生先进工作者<br>
            <span class="col33333">张良圣</span>—— 全国先进工作者、全国卫生系统先进工作者、全国第五批名老中医药专家学术指导老师<br>
            <span class="col33333">谷井文</span>—— 国务院政府特殊津贴专家、全国先进工作者、全国卫生系统先进工作者<br>
            <span class="col33333">蒋孟良</span>—— 国家中医药管理局重点学科中药炮制学科带头人、国家中药炮制基地建设传承人、国家中医管理局中医药科技专家<br>
          </div>
        </div>
        <div class="banner3-Box">
          <div class="banner3-tlt">
            国家药典标准精选 <span class="col33333">-</span> 道地药材
          </div>
          <div class="banner3-text">
            遵循道地药材的选材原则，从采购、验收等源头
            环节严控把关，所有原材均从全国正规药材厂选购，并由专业执业药师二次管控验收，以高达5%的拒收率，
            确保药材质量符合甚至高于国家药典、省炮制规范标准。
          </div>
          <div class="banner3-img"></div>
        </div>
        <div class="banner4-Box">
          <div class="banner-tlt">产品版图</div>
          <div class="banner-textP banner4-text">
            品类：中医药食同源食品、保健品、OTC <br>
            剂型：膏滋、固体饮料、液态饮品、片剂
          </div>
          <div class="banner4-img"></div>
        </div>
      </div>
    </div>
    <FooterNavigation/>
  </div>
</template>

<script>
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import { myFun, } from '../../plug/modifyImagePath';

export default {
  name: 'aboutProducts',
  components: {TopNavigation, FooterNavigation, },
  title () {
    return {
      title: '减肥产品介绍|脂玫乐产品优势|名医研发团队-脂玫乐',
      keywords: '脂玫乐产品，脂玫乐优势，脂玫乐名医研发团队',
      description: '脂玫乐健康瘦身品牌，专业为用户提供“体质管理+营养管理+作息管理”三位一体健康瘦身方案。',
    };
  },
  data () {
    return {
      src1: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/aboutProducts/wangjuan.png'),
      src3: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/aboutProducts/pengyanmei.png'),
      src4: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/aboutProducts/liuziyu.png'),
      src5: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/aboutProducts/jiangmengliang.png'),
      src6: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/aboutProducts/liuminghan.png'),
      src7: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/aboutProducts/zhangliangsheng.png'),
      src8: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/aboutProducts/gujinwen.png'),
    };
  },
};
</script>

<style lang="less" scoped>
  @media screen and (max-width: 800px) {
    @import url("./aboutProductsPhone.less");
  }

  @media screen and (min-width: 801px) {
    @import url('./aboutProducts.less');
  }
</style>



// WEBPACK FOOTER //
// aboutProducts.vue